import DOMPurify from 'dompurify';

export function sanitize(content) {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'u', 'ins', 'p']
  });
}
